import React, { useEffect, useState } from "react";
import SideBar from "../../components/SideBar";
import axios from "axios";
import Header from "../../components/Header";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@mui/material";

function Sales() {
  const [salesData, setSalesData] = useState([]);
  const [filteredSales, setFilteredSales] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  console.log("Sales data:", salesData);
  const [page, setPage] = useState(0); // State for current page
  const rowsPerPage = 10; // Rows per page

  useEffect(() => {
    setLoading(true);
    axios
      .get("https://nyatapol.biz/cafe_resturant/api/reports/getalldata")
      .then((res) => {
        const invoices = res.data.invoices || [];
        const orders = res.data.orders || [];

        const mergedData = invoices.map((invoice) => {
          const order = orders.find((o) => o.id === invoice.order_id);

          // Merge each invoice item with matching order item by id
          const enrichedItems = (invoice.items || []).map((invItem) => {
            const orderItem = order?.items?.find((oi) => oi.id === invItem.id);
            return {
              name: orderItem?.item_name || "N/A",
              quantity: orderItem?.quantity || "N/A",
              amount: invItem.amount,
            };
          });

          return {
            id: invoice.id,
            date: invoice.issued_at.split(" ")[0],
            invoice_number: invoice.invoice_number,
            table_number: order?.table_id || "N/A",
            total_amount: invoice.total_amount,
            discount: invoice.discount,
            service_charge: invoice.service_charge,
            payment_method: invoice.payment_method,
            vat_percentage: invoice.vat_percentage,
            grand_total: invoice.grand_total,
            items: enrichedItems,
          };
        });

        setSalesData(mergedData);
        setFilteredSales(mergedData);
      })
      .catch((err) => {
        setError("Failed to load sales data.");
        console.error(err);
      })
      .finally(() => setLoading(false));
  }, []);

  const filterSales = () => {
    if (!fromDate || !toDate) return;

    const filtered = salesData.filter((sale) => {
      return sale.date >= fromDate && sale.date <= toDate;
    });
    setFilteredSales(filtered);
  };

  const handleViewDetails = (invoice) => {
    setSelectedInvoice(invoice);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedInvoice(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <SideBar />
      <Header />
      <div className="MainContainer">
        <div className="ReportContainer">
          <h1 className="Titlesssss">Sales Report</h1>
          <div className="HeaderBox">
            <Box display="flex" gap={2} alignItems="center" className="Fillter">
              <TextField
                label="From"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                size="small"
              />
              <TextField
                label="To"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                size="small"
              />
              <Button variant="contained" color="primary" onClick={filterSales}>
                Filter
              </Button>
            </Box>
            <div className="Export">
              {/* <button>Export in Excel</button> */}
            </div>
          </div>

          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p className="text-red-500">{error}</p>
          ) : (
            <div className="ReportList MenuList">
              <table className="w-full border text-sm">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-2 py-1">S.N.</th>
                    <th className="border px-2 py-1">Date</th>
                    <th className="border px-2 py-1">Invoice Number</th>
                    <th className="border px-2 py-1">Table Number</th>
                    <th className="border px-2 py-1">Total Amount</th>
                    {/* <th className="border px-2 py-1">Discount</th>
                    <th className="border px-2 py-1">Service Charge</th> */}
                    <th className="border px-2 py-1">payment_method</th>
                    <th className="border px-2 py-1">Vat</th>
                    <th className="border px-2 py-1">Grand Amount</th>
                    <th className="border px-2 py-1">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredSales.length > 0 ? (
                    filteredSales
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((sale, index) => (
                        <tr key={index}>
                          <td>{page * rowsPerPage + index + 1}</td>
                          <td className="border px-2 py-1">{sale.date}</td>
                          <td className="border px-2 py-1">
                            {sale.invoice_number}
                          </td>
                          <td>{sale.table_number}</td>
                          <td>{sale.total_amount}</td>
                          {/* <td>{sale.discount}</td>
                          <td>{sale.service_charge}</td> */}
                          <td>{sale.payment_method}</td>
                          <td>{sale.vat_percentage}</td>
                          <td>{sale.grand_total}</td>
                          <td className="Actionsss">
                            <button
                              onClick={() => handleViewDetails(sale)}
                              className="bg-green-500 text-white px-2 py-1 rounded"
                            >
                              View
                            </button>
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center py-4">
                        No sales found for selected date range.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <TablePagination
                component="div"
                count={filteredSales.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[]}
              />
            </div>
          )}
        </div>
      </div>

      {/* Dialog for viewing details */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Invoice Details</DialogTitle>
        <DialogContent dividers>
          {selectedInvoice ? (
            <>
              <Typography gutterBottom>Date: {selectedInvoice.date}</Typography>
              <Typography gutterBottom>
                Invoice #: {selectedInvoice.invoice_number}
              </Typography>
              <Typography gutterBottom>
                Table: {selectedInvoice.table_number}
              </Typography>
              <Typography gutterBottom>
                Total Amount: {selectedInvoice.total_amount}
              </Typography>
              <Typography gutterBottom>
                Discount: {selectedInvoice.discount}
              </Typography>
              <Typography gutterBottom>
                Service Charge: {selectedInvoice.service_charge}
              </Typography>
              <Typography gutterBottom>
                Vat: {selectedInvoice.vat_percentage}
              </Typography>
              <Typography gutterBottom>
                Grand Total: {selectedInvoice.grand_total}
              </Typography>

              <Typography variant="h6" sx={{ mt: 2 }}>
                Items
              </Typography>
              <TableContainer component={Paper} sx={{ mt: 1 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Item Name</TableCell>
                      <TableCell>Quantity</TableCell>
                      <TableCell>Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedInvoice.items.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{item.name}</TableCell>
                        <TableCell>{item.quantity}</TableCell>
                        <TableCell>{item.amount}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (
            <Typography>No details found.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Sales;
